import { createSelector } from 'reselect'
import { API_URL_VEHICLECODE } from '../../../constants/apiUrls'
import pendingRequestsSelector from './pendingRequestsSelector'
import requestIsPending from './helpers/requestIsPending'

const vehicleCodeRequestIsPendingSelector = createSelector(
    pendingRequestsSelector,
    (pendingRequests): boolean => requestIsPending(pendingRequests, API_URL_VEHICLECODE),
)

export default vehicleCodeRequestIsPendingSelector
